import { Checkbox, CheckboxProps } from "antd";

import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";

import { Option } from "../../../shared/interface";

export interface CustomCheckboxProps extends CheckboxProps {
  onChange?: (e: any) => void;
  options?: Option[];
  optionMargin?: string;
  margin?: string;
  fontWeight?: number;
  optionHeight?: string;
  value?: any[];
  disabledValues?: string[];
}

const CheckBox: React.FC<CustomCheckboxProps> = ({
  disabled,

  name,
  disabledValues = [],
  value = [],
  options = [],
  onChange,
  margin,
  optionMargin,
  optionHeight,

  fontWeight,
}) => {
  const styles = {
    disabled,
    name,
    value,
    margin,
    fontWeight,
  };

  return (
    <CheckboxInpput {...styles} onChange={onChange}>
      {/* childre이 있을 경우 children */}
      {/* children이 없을 경우 map으로 자식들을 순회함 */}
      {options.map((e) => {
        const isBoxDisabled =
          disabled || disabledValues?.length > 0
            ? disabledValues.includes(e.value)
            : false;
        return (
          <StyledCheckbox
            optionMargin={optionMargin}
            key={e.value}
            isDisabled={disabled}
            disabled={disabled || isBoxDisabled}
            value={e.value}
            fontWeight={fontWeight}
            optionHeight={optionHeight}
          >
            {e.label}
          </StyledCheckbox>
        );
      })}
    </CheckboxInpput>
  );
};

export default CheckBox;

const CheckboxInpput = styled(Checkbox.Group)<{ margin?: string }>`
  width: fit-content;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: ${({ margin }) => margin || "0px 0px 0px 0px"};
  & > .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0px;
  }
`;
const StyledCheckbox = styled(Checkbox)<{
  optionMargin?: string;
  isDisabled?: boolean;
  fontWeight?: number;
  optionHeight?: string;
}>`
  transition: all 0.3s;
  margin: ${({ optionMargin }) => optionMargin || "0 8px 0 0"};
  line-height: ${({ optionHeight }) => optionHeight || "24px"};
  height: ${({ optionHeight }) => optionHeight || "24px"};

  .ant-checkbox + span {
    font-weight: ${({ fontWeight }) => fontWeight || 400};
  }
  .ant-checkbox-checked.ant-checkbox-disabled + span {
    color: ${theme.colors.gray1};
  }

  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: ${theme.colors.gray7};
  }
  .ant-checkbox-disabled .ant-checkbox-inner {
    background-color: ${theme.colors.gray9};
  }
  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${theme.colors.gray9};
  }
`;
